<template>
  <section class="app-table-wrap sales-flat-rates-table-wrap">
    <div class="app-table-scroll">
      <table class="app-data-table">
        <thead>
          <tr>
            <th class="app-col-index">#</th>
              <th>
                <button
                  type="button"
                  class="payments-table-sort-btn"
                  :title="text.table.sortTitles.month"
                  @click="requestSort('month')"
                >
                  <span>{{ text.table.columns.month }}</span>
                  <i class="fa" :class="sortIconClass('month')" aria-hidden="true"></i>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  class="payments-table-sort-btn"
                  :title="text.table.sortTitles.business"
                  @click="requestSort('business')"
                >
                  <span>{{ text.table.columns.business }}</span>
                  <i class="fa" :class="sortIconClass('business')" aria-hidden="true"></i>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  class="payments-table-sort-btn"
                  :title="text.table.sortTitles.service"
                  @click="requestSort('service')"
                >
                  <span>{{ text.table.columns.service }}</span>
                  <i class="fa" :class="sortIconClass('service')" aria-hidden="true"></i>
                </button>
              </th>
              <th class="app-text-right">
                <button
                  type="button"
                  class="payments-table-sort-btn payments-table-sort-btn--right"
                  :title="text.table.sortTitles.subtotal"
                  @click="requestSort('subtotal')"
                >
                  <span>{{ text.table.columns.subtotal }}</span>
                  <i class="fa" :class="sortIconClass('subtotal')" aria-hidden="true"></i>
                </button>
              </th>
              <th>{{ text.table.columns.taxes }}</th>
              <th class="app-text-right">
                <button
                  type="button"
                  class="payments-table-sort-btn payments-table-sort-btn--right"
                  :title="text.table.sortTitles.total"
                  @click="requestSort('total')"
                >
                  <span>{{ text.table.columns.total }}</span>
                  <i class="fa" :class="sortIconClass('total')" aria-hidden="true"></i>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  class="payments-table-sort-btn"
                  :title="text.table.sortTitles.invoice"
                  @click="requestSort('invoice')"
                >
                  <span>{{ text.table.columns.invoice }}</span>
                  <i class="fa" :class="sortIconClass('invoice')" aria-hidden="true"></i>
                </button>
              </th>
              <th>
                <button
                  type="button"
                  class="payments-table-sort-btn"
                  :title="text.table.sortTitles.payment"
                  @click="requestSort('payment')"
                >
                  <span>{{ text.table.columns.payment }}</span>
                  <i class="fa" :class="sortIconClass('payment')" aria-hidden="true"></i>
                </button>
              </th>
              <th>{{ text.table.columns.status }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
              <td colspan="11" class="app-table-empty">{{ text.table.loading }}</td>
          </tr>

          <tr v-else-if="normalizedRows.length === 0">
            <td colspan="11" class="app-table-empty">{{ emptyText }}</td>
          </tr>

          <tr v-else v-for="(row, index) in normalizedRows" :key="row.id || index">
            <td class="app-muted">{{ rowNumber(index) }}</td>
            <td>{{ resolveMonthLabel(row) }}</td>
            <td>
              <a
                v-if="resolveCustomerId(row) > 0"
                :href="resolveCustomerHref(row)"
                class="sales-table-link sales-flat-rates-table__line sales-flat-rates-table__line-strong"
                  :title="text.table.links.customerDetail"
                @click="navigateToCustomerDetail(row, $event)"
              >
                {{ row.customer_name || '-' }}
              </a>
              <p v-else class="sales-flat-rates-table__line sales-flat-rates-table__line-strong">{{ row.customer_name || '-' }}</p>

              <a
                v-if="resolveSaleId(row) > 0"
                :href="resolveSaleHref(row)"
                class="sales-table-link sales-flat-rates-table__line"
                  :title="text.table.links.saleDetail"
                @click="navigateToSaleDetail(row, $event)"
              >
                  {{ resolveBusinessLabel(row) }}
              </a>
                <p v-else class="sales-flat-rates-table__line">{{ resolveBusinessLabel(row) }}</p>
            </td>
            <td>
              <p class="sales-flat-rates-table__line">{{ row.service_type || '-' }}</p>
              <p class="sales-flat-rates-table__line sales-flat-rates-table__line-strong">{{ row.product_name || '-' }}</p>
            </td>
            <td class="app-text-right app-strong">
              <strong class="amount-cell-subtotal">{{ formatAmountWithCurrency(resolveSubtotal(row), row.currency) }}</strong>
            </td>
            <td>
              <div class="payments-cell-stack" v-if="resolveTaxItems(row).length > 0">
                <small
                  v-for="(taxItem, taxIndex) in resolveTaxItems(row)"
                  :key="`${row.id || index}-tax-${taxIndex}`"
                  class="amount-cell-tax-line"
                >
                  {{ formatTaxLine(taxItem, row.currency) }}
                </small>
              </div>
              <span v-else></span>
            </td>
            <td class="app-text-right app-strong">
              <div class="amount-cell">
                <span class="amount-cell-total">{{ formatAmountWithCurrency(resolveTotal(row), row.currency) }}</span>
                <small v-if="isForeignCurrency(row.currency)" class="amount-cell-exchange-rate">
                  {{ text.table.exchangeRatePrefix }} {{ formatExchangeRate(resolveExchangeRate(row)) }}
                </small>
              </div>
            </td>
            <td>
              <p class="sales-flat-rates-table__line">{{ formatDate(row.invoice_date) }}</p>
              <button
                  v-if="canIssueInvoice(row)"
                type="button"
                class="payments-action-link"
                @click="$emit('invoice-sale', row)"
              >
                  {{ text.table.actions.issueInvoice }}
              </button>
                <button
                  v-else-if="canIssueSimpleNote(row)"
                  type="button"
                  class="payments-action-link"
                  @click="$emit('simple-note-sale', row)"
                >
                  {{ text.table.actions.issueSimpleNote }}
                </button>
                <a
                  v-else-if="canOpenInvoiceDetail(row)"
                  :href="resolveInvoiceHref(row)"
                  class="payments-table-link payment-billing-link"
                  :title="text.table.links.invoiceDetail"
                  @click="navigateToInvoiceDetail(row, $event)"
                >
                  {{ resolveBillingReference(row) || text.table.links.invoiceDefaultLabel }}
                </a>
                <span v-else class="payment-billing-reference">{{ resolveBillingReference(row) }}</span>
            </td>
            <td>
              <p class="sales-flat-rates-table__line">{{ formatDate(row.payment_date) }}</p>
              <button
                  v-if="canShowPayButton(row)"
                type="button"
                class="payments-action-link"
                @click="$emit('pay-sale', row)"
              >
                  {{ text.table.actions.pay }}
              </button>
                <span v-else class="payment-reference">{{ resolvePaymentReference(row) }}</span>
            </td>
            <td>
              <span class="app-status-pill" :class="resolveStatusClass(row)">{{ resolveStatusLabel(row) }}</span>
            </td>
            <td class="app-table-actions-cell">
              <div class="app-table-actions-inline">
                <button
                  type="button"
                  class="app-table-icon-btn app-table-icon-btn--view"
                    :title="text.table.actions.viewSale"
                  @click="$emit('view-sale', row)"
                >
                  <i class="fa fa-eye" aria-hidden="true"></i>
                </button>

                <button
                  type="button"
                  class="app-table-icon-btn app-table-icon-btn--edit"
                    :title="text.table.actions.editSale"
                  @click="$emit('edit-sale', row)"
                >
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>

                <button
                  type="button"
                  class="app-table-icon-btn app-table-icon-btn--delete"
                  :title="text.table.actions.delete"
                  @click="$emit('delete-sale', row)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="normalizedPagination.total_pages > 1" class="app-table-footer">
      <AppPagination
        :current-page="normalizedPagination.current_page"
        :total-pages="normalizedPagination.total_pages"
        @page-change="$emit('page-change', $event)"
      />
    </div>
  </section>
</template>

<script>
import AppPagination from '@/components/common/AppPagination.vue';
import { formatDateShort } from '@/utils/datePresentation';
import {
  formatAmountWithCurrency,
  formatExchangeRate,
  getRequiredExchangeRate,
  isForeignCurrency,
} from '@/utils/numberFormat';
import { formatCodeName } from '@/utils/textValue';
import { useDomainText } from '@/composables/text/useDomainText';
import { formatTaxLine } from '@/composables/shared/useTaxPresentation';
import {
  navigateToRouteDetail,
  resolveRouteHref,
} from '@/composables/shared/useNavigation';
import {
  canIssuePaymentInvoice,
  canIssuePaymentSimpleNote,
  canOpenPaymentInvoiceDetail,
  canShowPayActionButton,
  hasPaymentInvoiceDocument,
  hasSimpleNoteVoucherDocument,
  isSimpleNotePaymentVoucher,
  resolvePaymentBillingReference,
  resolvePaymentInvoiceId,
} from '@/composables/shared/usePaymentVoucherActions';
import {
  resolveSortIconClass,
  resolveSortTogglePayload,
} from '@/composables/shared/useSorting';

const { catalog: text } = useDomainText('flatRates');

export default {
  name: 'SalesFlatRatesTable',
  components: {
    AppPagination,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Sin igualas disponibles para los filtros seleccionados.',
    },
    pagination: {
      type: Object,
      default: () => ({
        current_page: 1,
        per_page: 30,
        total_pages: 1,
        total_items: 0,
      }),
    },
    sortField: {
      type: String,
      default: 'month',
    },
    sortDirection: {
      type: String,
      default: 'desc',
    },
  },
  emits: [
    'invoice-sale',
    'simple-note-sale',
    'pay-sale',
    'change-sale-status',
    'edit-sale',
    'view-sale',
    'delete-sale',
    'page-change',
    'sort-change',
  ],
  data() {
    return {
      text,
    };
  },
  computed: {
    normalizedRows() {
      return Array.isArray(this.rows) ? this.rows : [];
    },
    normalizedPagination() {
      const raw = this.pagination || {};

      return {
        current_page: Number(raw.current_page || 1),
        per_page: Number(raw.per_page || 30),
        total_pages: Number(raw.total_pages || 1),
        total_items: Number(raw.total_items || 0),
      };
    },
  },
  methods: {
    formatAmountWithCurrency,
    formatExchangeRate,
    isForeignCurrency,
    formatTaxLine,
    sortIconClass(field) {
      return resolveSortIconClass(
        {
          field: this.sortField,
          direction: this.sortDirection,
        },
        field,
      );
    },
    requestSort(field) {
      const nextSort = resolveSortTogglePayload(
        {
          field: this.sortField,
          direction: this.sortDirection,
        },
        field,
      );

      if (!nextSort) {
        return;
      }

      this.$emit('sort-change', nextSort);
    },
    formatDate(value) {
      return formatDateShort(value);
    },
    resolveBusinessLabel(row) {
      return formatCodeName(row?.sale_code, row?.sale_name) || '-';
    },
    resolveMonthLabel(row) {
      return String(row?.month_label || row?.mes || '').trim() || '-';
    },
    resolveExchangeRate(row) {
      return getRequiredExchangeRate(row);
    },
    resolveSubtotal(row) {
      const value = Number(row?.subtotal ?? row?.amount ?? 0);
      return Number.isFinite(value) ? value : 0;
    },
    resolveTotal(row) {
      const explicitTotal = Number(row?.total || 0);
      if (Number.isFinite(explicitTotal) && explicitTotal > 0) {
        return explicitTotal;
      }

      const subtotal = this.resolveSubtotal(row);
      const transferred = Number(row?.taxes?.transferred_total || 0) || 0;
      const withheld = Number(row?.taxes?.withheld_total || 0) || 0;

      return subtotal + transferred - withheld;
    },
    resolveTaxItems(row) {
      const items = Array.isArray(row?.taxes?.items) ? row.taxes.items : [];
      if (items.length > 0) {
        return items;
      }

      const transferred = Number(row?.taxes?.transferred_total || 0) || 0;
      const withheld = Number(row?.taxes?.withheld_total || 0) || 0;
      const fallback = [];

      if (transferred > 0) {
        fallback.push({ name: this.text.table.taxes.transferred, direction: 'trasladado', amount: transferred });
      }

      if (withheld > 0) {
        fallback.push({ name: this.text.table.taxes.withheld, direction: 'retenido', amount: withheld });
      }

      return fallback;
    },
    resolveSaleId(row) {
      return Number(row?.sale_id || row?.id || 0);
    },
    resolveCustomerId(row) {
      return Number(row?.company_id || 0);
    },
    resolveCustomerHref(row) {
      return resolveRouteHref(this.$router, 'customerDetail', 'customerId', this.resolveCustomerId(row));
    },
    resolveSaleHref(row) {
      return resolveRouteHref(this.$router, 'saleDetail', 'saleId', this.resolveSaleId(row));
    },
    navigateToCustomerDetail(row, event = null) {
      navigateToRouteDetail(this.$router, 'customerDetail', 'customerId', this.resolveCustomerId(row), event);
    },
    navigateToSaleDetail(row, event = null) {
      navigateToRouteDetail(this.$router, 'saleDetail', 'saleId', this.resolveSaleId(row), event);
    },
    rowNumber(index) {
      const currentPage = Number(this.normalizedPagination.current_page || 1);
      const perPage = Number(this.normalizedPagination.per_page || 30);

      return ((currentPage - 1) * perPage) + Number(index) + 1;
    },
    resolveStatusLabel(row) {
      const position = String(row?.number_pay_position || '').trim().toLowerCase();
      if (position === 'first') {
        return this.text.table.status.newFlatRate;
      }

      if (position === 'last') {
        return this.text.table.status.lastMonth;
      }

      return String(row?.status_name || '').trim() || this.text.table.status.fallback;
    },
    resolveStatusClass(row) {
      const position = String(row?.number_pay_position || '').trim().toLowerCase();
      if (position === 'first') {
        return 'sales-flat-rates-status--first';
      }

      if (position === 'last') {
        return 'sales-flat-rates-status--last';
      }

      return Number(row?.status_is_open || 0) === 1
        ? 'app-status-active'
        : 'app-status-inactive';
    },
    isSimpleNoteVoucher(row) {
      return isSimpleNotePaymentVoucher(row);
    },
    hasInvoice(row) {
      return hasPaymentInvoiceDocument(row);
    },
    resolveInvoiceId(row) {
      return resolvePaymentInvoiceId(row);
    },
    canOpenInvoiceDetail(row) {
      return canOpenPaymentInvoiceDetail(row);
    },
    resolveInvoiceHref(row) {
      return resolveRouteHref(this.$router, 'invoiceDetail', 'invoiceId', this.resolveInvoiceId(row));
    },
    navigateToInvoiceDetail(row, event = null) {
      if (!this.canOpenInvoiceDetail(row)) {
        return;
      }

      navigateToRouteDetail(
        this.$router,
        'invoiceDetail',
        'invoiceId',
        this.resolveInvoiceId(row),
        event,
      );
    },
    hasSimpleNote(row) {
      return hasSimpleNoteVoucherDocument(row);
    },
    hasPayment(row) {
      if (Number(row?.payment_pending || 0) !== 1) {
        return true;
      }

      const paid = Number(row?.paid || 0);
      if (Number.isFinite(paid) && paid > 0) {
        return true;
      }

      return String(row?.payment_reference || '').trim() !== '';
    },
    resolveBillingReference(row) {
      return resolvePaymentBillingReference(row);
    },
    resolvePaymentReference(row) {
      return String(row?.payment_reference || '').trim();
    },
    isPaid(row) {
      if (Number(row?.payment_pending || 0) !== 1) {
        return true;
      }

      return Number(row?.paid || 0) > 0;
    },
    canIssueInvoice(row) {
      return canIssuePaymentInvoice(row, { isPaid: this.isPaid(row) });
    },
    canIssueSimpleNote(row) {
      return canIssuePaymentSimpleNote(row);
    },
    canShowPayButton(row) {
      return canShowPayActionButton(row, { hasPayment: this.hasPayment(row) });
    },
  },
};
</script>
<style scoped lang="scss" src="@/assets/scss/components/sales/_sales-flat-rates-table.scss"></style>
